import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import { ArticleCard } from "@baseComponents/ArticleCard";
import { useMediaQueryBreakpoint } from "@hooks";
import { portfolioArticleCards } from "@portfolios";

import {
  CaseStudiesContainer,
  CaseStudiesHeader,
  CaseStudiesSection,
  CaseStudiesSubheader,
} from "./styles.styled";

export const ContactCaseStudies = () => {
  const { t } = useTranslation();
  const { isDesktopXl, tabletThreshold } = useMediaQueryBreakpoint();
  const { locale } = useRouter();

  return (
    <CaseStudiesSection>
      <div className="flex flex-col gap-2">
        <CaseStudiesHeader>
          {t("contact-page.case-study-header")}
        </CaseStudiesHeader>

        <CaseStudiesSubheader>
          {t("contact-page.case-study-subheader")}
        </CaseStudiesSubheader>
      </div>

      <CaseStudiesContainer>
        {portfolioArticleCards.slice(0, 2).map(article => {
          const card =
            locale && Object.keys(article).includes(locale)
              ? article[locale as keyof typeof article]
              : article.en;

          return (
            <ArticleCard
              key={card.title}
              size={isDesktopXl ? "medium" : "small"}
              nextImageSizes={`(min-width: ${tabletThreshold}px) 50vw, 100vw`}
              {...card}
            />
          );
        })}
      </CaseStudiesContainer>
    </CaseStudiesSection>
  );
};
